const LOAD_FILTERVALUEGROUPS = "LOAD_FILTERVALUEGROUPS";
const LOAD_FILTERVALUEGROUPS_SUCCESS = "LOAD_FILTERVALUEGROUPS_SUCCESS";
const LOAD_FILTERVALUEGROUPS_FAIL = "LOAD_FILTERVALUEGROUPS_FAIL";

const FILTERVALUEGROUP_POST = "FILTERVALUEGROUP_POST";
const FILTERVALUEGROUP_DELETE = "FILTERVALUEGROUP_DELETE";

export default function filterValueGroup(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
  },
  action,
) {
  switch (action.type) {
    case LOAD_FILTERVALUEGROUPS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_FILTERVALUEGROUPS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_FILTERVALUEGROUPS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    default:
      return state;
  }
}

export function getFilterValueGroups() {
  return {
    type: LOAD_FILTERVALUEGROUPS,
    payload: {
      request: {
        url: "FilterValueGroup/",
      },
    },
  };
}

export function addOrEditFilterValueGroup(FilterValueGroup) {
  return {
    type: FILTERVALUEGROUP_POST,
    payload: {
      request: {
        url: "FilterValueGroup",
        method: "POST",
        data: FilterValueGroup,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilterValueGroups());
        },
      },
    },
  };
}

export function deleteFilterValueGroup(id) {
  return {
    type: FILTERVALUEGROUP_DELETE,
    payload: {
      request: {
        url: "FilterValueGroup/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilterValueGroups());
        },
      },
    },
  };
}
